import {
  emailAdentisRegex,
  emailRegex,
  passwordRegex,
  emailInternalRegex,
} from "../common/GeneralConfigurations";

export const AdnValidationAdentisEmail = [
  { required: true, message: "Email is required" },
  { pattern: emailRegex, message: "Invalid Email" }, //adentis email is not required
];

export const AdnValidationEmail = [
  { required: true, message: "Email is required" },
  { pattern: emailRegex, message: "Invalid Email" },
];

export const AdnInternalEmail = [
  { required: true, message: "Email is required" },
  { pattern: emailRegex, message: "Invalid Email" },
];

export const AdnValidationPassword = [
  { required: true, message: "Password is required" },
  {
    pattern: passwordRegex,
    message:
      "At least 8 characters, one lowercase, one uppercase letters, one number and one special character",
  },
];
